import KioAppHelper from './kioApp';

// Optional UI scaling mode. When scaling is enabled (VITE_DESIGN_SCALING_ENABLED or
// VITE_ST_BPK_DESIGN_SCALING_ENABLED is exactly "true"), the layout is pinned to a fixed
// portrait design resolution (default 1080x1920) and scaled uniformly to fit the
// actual viewport. Disabled by default; when disabled, the original fluid layout
// is used unchanged.
//
// When enabled, this module:
//   - adds the html.ui-scaled class (gates stage rules in _reset.scss)
//   - publishes --design-width / --design-height on documentElement
//   - publishes --stage-fill-width / --stage-fill-height (100%) so child
//     stylesheets switch from 100vw/100vh to filling the stage
//   - recomputes --ui-scale on load and on every window resize

const DEFAULT_DESIGN_WIDTH = 1080;
const DEFAULT_DESIGN_HEIGHT = 1920;

function resolveKwOrEnv(substitutionString: string | undefined, envValue: string | undefined): string | undefined {
	const fromKw = substitutionString ? KioAppHelper('DoUrlSubstitution', substitutionString) : null;
	// null = KioApp unavailable; literal token (contains "$$") = not configured in KioWare
	if (fromKw && !fromKw.includes('$$')) return fromKw;
	return envValue;
}

export function initUiScaling(): void {
	const enabled = resolveKwOrEnv(import.meta.env.VITE_ST_BPK_DESIGN_SCALING_ENABLED, import.meta.env.VITE_DESIGN_SCALING_ENABLED);
	if (enabled !== 'true') {
		return;
	}

	const widthStr = resolveKwOrEnv(import.meta.env.VITE_ST_BPK_DESIGN_WIDTH, import.meta.env.VITE_DESIGN_WIDTH);
	const heightStr = resolveKwOrEnv(import.meta.env.VITE_ST_BPK_DESIGN_HEIGHT, import.meta.env.VITE_DESIGN_HEIGHT);
	const designWidth = Number(widthStr) || DEFAULT_DESIGN_WIDTH;
	const designHeight = Number(heightStr) || DEFAULT_DESIGN_HEIGHT;
	const root = document.documentElement;

	root.classList.add('ui-scaled');
	root.style.setProperty('--design-width', `${designWidth}px`);
	root.style.setProperty('--design-height', `${designHeight}px`);
	root.style.setProperty('--stage-fill-width', '100%');
	root.style.setProperty('--stage-fill-height', '100%');

	const applyUiScale = () => {
		const scale = Math.min(window.innerWidth / designWidth, window.innerHeight / designHeight);
		root.style.setProperty('--ui-scale', String(scale));
	};

	applyUiScale();
	window.addEventListener('resize', applyUiScale);
}
